import moment from 'moment';

moment.locale('cs');

export default (date) => {
  return moment(date).format('D. M. YYYY');
};
